import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';
import { FreeTextSearch } from '../../common/schema/hannibal/types.generated';
import { SearchResultItem } from '../types';
import { useNonProfilesOnly } from '../useNonProfilesOnly';
import { NoResults } from './NoResults/NoResults';
import { ResultList } from './ResultList/ResultList';
import { TelehealthActionsVariations } from './ResultList/TelehealthActions/TelehealthActions';
import { ResultLoading } from './ResultLoading/ResultLoading';
import { Inner, List, ResultViewDisplay } from './ResultView.styles';

export interface Props {
  fetchingMore?: boolean;
  filters: FilterChoice;
  loading?: boolean;
  onClickMore: VoidFunction;
  searchResults: SearchResultItem[];
  searchSpecialty?: string;
  telehealthSearchCardsVariant?: TelehealthActionsVariations;
  totalCount?: number;
  headerText?: string;
  hideAds?: boolean;
  showingExtended?: boolean;
  extendedResults?: FreeTextSearch;
  extendedFetchMore?: VoidFunction;
  extendedFetchingMore?: boolean;
  useFilterOffset?: boolean;
}

export const ResultView = ({
  fetchingMore = false,
  filters,
  loading = true,
  onClickMore,
  searchResults,
  searchSpecialty,
  telehealthSearchCardsVariant,
  totalCount,
  headerText,
  showingExtended,
  extendedResults,
  extendedFetchMore,
  extendedFetchingMore,
  useFilterOffset,
}: Props) => {
  const nonProfiles = useNonProfilesOnly(searchResults);

  // Do the search results include any practice or practitioner results?
  const hasProfiles = searchResults.length > nonProfiles.length;

  return (
    <>
      <ResultViewDisplay useOffset={useFilterOffset}>
        <Inner>
          <List>
            {searchResults.length === 0 && loading && <ResultLoading />}

            {!loading && hasProfiles && (
              <ResultList
                fetchingMore={fetchingMore}
                filters={filters}
                loading={loading}
                onClickMore={onClickMore}
                results={searchResults}
                searchSpecialty={searchSpecialty}
                telehealthSearchCardsVariant={telehealthSearchCardsVariant}
                totalCount={totalCount ?? 0}
                headerText={headerText}
                extendedResults={extendedResults}
                extendedFetchMore={extendedFetchMore}
                extendedFetchingMore={extendedFetchingMore}
              />
            )}

            {!loading && !hasProfiles && (
              <NoResults
                loading={loading}
                items={nonProfiles}
                showingExtended={showingExtended}
                extendedResults={extendedResults}
                extendedFetchMore={extendedFetchMore}
                extendedFetchingMore={extendedFetchingMore}
              />
            )}
          </List>
        </Inner>
      </ResultViewDisplay>
    </>
  );
};
